import { getJobPostings } from "apps/careers/util/web";

// initial state
// ----------------------------------------------------------------------------

export const INITIAL_STATE = {
	isError: false,
	isLoading: true,
	postings: [],
};


// action types
// ----------------------------------------------------------------------------

export const FETCH_POSTINGS = "CAREERS.FETCH_POSTINGS";
export const FETCH_POSTINGS_SUCCESS = "CAREERS.FETCH_POSTINGS_SUCCESS";
export const FETCH_POSTINGS_ERROR = "CAREERS.FETCH_POSTINGS_ERROR";


// reducer
// ----------------------------------------------------------------------------

export const reducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case FETCH_POSTINGS: {
			return {
				...state,
				isLoading: true,
			};
		}

		case FETCH_POSTINGS_SUCCESS: {
			return {
				...state,
				postings: action.payload.postings,
				isLoading: false,
				isError: false,
			};
		}

		case FETCH_POSTINGS_ERROR: {
			return {
				...state,
				isLoading: false,
				isError: true,
			};
		}

		default: {
			return state;
		}
	}
};

// actions
// ----------------------------------------------------------------------------

export const fetchPostingsError = () => ({
	type: FETCH_POSTINGS_ERROR,
});

export const fetchPostingsSuccess = (postings) => ({
	type: FETCH_POSTINGS_SUCCESS,
	payload: { postings },
});

export const fetchPostings = () => (dispatch) => {
	dispatch({
		type: FETCH_POSTINGS,
	});

	return getJobPostings()
		.then((postings) => {
			dispatch(fetchPostingsSuccess(postings));
		})
		.catch((error) => {
			dispatch(fetchPostingsError(error));
		});
};



// WEBPACK FOOTER //
// ./src/ducks/careers.js